import clsx from 'clsx';

import { decodeHtmlEntities } from '../../helpers/decodeHtmlEntities';
import c from './_profileHeader.module.scss';

export interface ProfileHeaderProps {
  company: string;
  officialName?: string | null;
  subCatname: string | null;
  addr1: string | null;
  city: string | null;
}

export function ProfileHeader({ company, officialName, subCatname, addr1, city }: ProfileHeaderProps) {
  const propertyName = decodeHtmlEntities(company);
  const officialPropertyName = decodeHtmlEntities(officialName);
  const subCat = decodeHtmlEntities(subCatname);

  return (
    <div className="profile-header">
      <div className={clsx('header-output', c.headerOutput)}>
        <div className={clsx('inner-header-output', c.innerHeaderOutput)}>{propertyName}</div>
        <div style={{ clear: 'both' }} />
      </div>

      {officialPropertyName && (
        <div className={clsx('profile-header__official-name', c.officialName)}>{officialPropertyName}</div>
      )}

      <div className={clsx('header-location', c.headerLocation)}>
        {addr1}
        {addr1 && city && <br />}
        {city}

        {subCat && (
          <div className={clsx('inner-header-output', c.innerHeaderOutput)}>
            <span className={clsx('profile-header__subcategory', c.subcategory)}>{subCat}</span>
          </div>
        )}
      </div>
      <div style={{ clear: 'both' }} />
    </div>
  );
}
